import { render, staticRenderFns } from "./TableIncomeUnit.vue?vue&type=template&id=0fa6e351&lang=pug&"
import script from "./TableIncomeUnit.vue?vue&type=script&lang=ts&"
export * from "./TableIncomeUnit.vue?vue&type=script&lang=ts&"
import style0 from "./TableIncomeUnit.vue?vue&type=style&index=0&id=0fa6e351&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports